import { render, staticRenderFns } from "./PluginandTemplatesInteraction.vue?vue&type=template&id=b66b02d4&"
import script from "./PluginandTemplatesInteraction.vue?vue&type=script&lang=js&"
export * from "./PluginandTemplatesInteraction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports